<form *ngIf="isShowForm" [formGroup]="myForm" novalidate class="w-100 mt-3 inline-flex justify-content-center">
  <p-panel header="Видео" class="container-fluid">
    <ng-template pTemplate="content">

      <div class="flex flex-column">
        <span class="p-input-icon-left w-100">
          <i class="pi pi-link"></i>
          <input name="videoLink" formControlName="videoLink" type="text" class="w-full"
            placeholder="Вставьте ссылку для скачивания видеоролика (Yandex Disk и т.д.)"
            pInputText (ngModelChange)="onLog($event)" />
        </span>
        <div *ngIf="myForm.controls['videoLink'].invalid" role="alert" class="mt-2 alert alert-danger">Некорректная
          ссылка</div>
      </div>
      <p-messages severity="info">
        <ng-template pTemplate>
          <!-- <div class="flex">
            <p>Для записи презентации можно воспользоваться инструкцией</p>
            <a href="https://support.microsoft.com/ru-ru/office/%D0%B7%D0%B0%D0%BF%D0%B8%D1%81%D1%8C-%D1%81%D0%BB%D0%B0%D0%B9%D0%B4-%D1%88%D0%BE%D1%83-%D1%81-%D0%B7%D0%B0%D0%BA%D0%B0%D0%B4%D1%80%D0%BE%D0%B2%D1%8B%D0%BC-%D1%82%D0%B5%D0%BA%D1%81%D1%82%D0%BE%D0%BC-%D0%B8-%D0%BD%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B9%D0%BA%D0%BE%D0%B9-%D0%B2%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%B8-%D0%BF%D0%BE%D0%BA%D0%B0%D0%B7%D0%B0-%D1%81%D0%BB%D0%B0%D0%B9%D0%B4%D0%BE%D0%B2-0b9502c6-5f6c-40ae-b1e7-e47d8741161c#OfficeVersion=Office_2013_-_Office_2019" target="_blank">Запись слайд-шоу с закадровым текстом и настройкой времени показа слайдов</a>
          </div> -->
          Для участия в конкурсе VK клипов, запишите вертикальное видео с рассказом о вашем исследовании длиной не более
          двух минут и загрузите его на любой файлообменник. Ссылку на видео вставьте в соответствующее поле «Ссылка»
          вверху и нажмите на «Сохранить».
        </ng-template>
      </p-messages>


    </ng-template>

    <ng-template pTemplate="footer">
      <button [disabled]="myForm.controls['videoLink'].invalid" pButton type="button"
        class="p-button-sm p-button-warning mr-3" label="Сохранить" icon="pi pi-save" (click)="onSave()"></button>

      <button *ngIf="myForm.controls['videoLink'].value !== ''" [disabled]="myForm.controls['videoLink'].invalid"
        pButton type="button" class="p-button-sm p-button-info" label="Перейти" icon="pi pi-external-link"
        (click)="onFollowTheLink()"></button>

    </ng-template>
  </p-panel>
</form>
